import { getUserRoles } from "@/api/permissions";

const state = {
  data: {},
  roles: [],
};

const mutations = {
  SET_USER(state, response) {
    state.data = response;
  },
  SET_ROLES(state, response) {
    state.roles = response;
  },
};

const actions = {
  async setUser({ commit }, payload) {
    commit("SET_USER", payload);
    try {
      const { data } = await getUserRoles(payload.sub);
      commit("SET_ROLES", data || []);
    } catch (e) {
      console.error(e);
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
